import { render, staticRenderFns } from "./finishedPedidos.vue?vue&type=template&id=76b6d578&scoped=true&"
import script from "./finishedPedidos.vue?vue&type=script&lang=js&"
export * from "./finishedPedidos.vue?vue&type=script&lang=js&"
import style0 from "./finishedPedidos.vue?vue&type=style&index=0&id=76b6d578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b6d578",
  null
  
)

export default component.exports